/**
 * Página: Telecomunicações
 */
import SegmentPage from '../../components/SegmentPage'

const segment = {
  name: 'Telecomunicações',
  tagline: 'Equipes externas sob controle total.',
  description: 'Gestão de técnicos em campo, instaladores e equipes externas. Ponto com geolocalização e compliance com NR-10 e NR-35.',
  icon: '📡',
  color: '#3B82F6',
  gradient: 'linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%)',
  painPoints: [
    'Técnicos em campo sem controle de jornada',
    'Dificuldade de comprovar presença no cliente',
    'Trabalho em altura sem verificação de EPI',
    'Equipes dispersas geograficamente',
    'Fraude no registro de ponto externo',
    'Compliance com NR-10 para eletricidade',
  ],
  benefits: [
    'Ponto facial com geolocalização GPS',
    'Comprovação de presença no endereço do cliente',
    'Verificação de EPI antes de subir no poste',
    'Gestão de múltiplas equipes por região',
    'Rastreamento de produtividade em campo',
    'Relatórios por técnico e por região',
  ],
  nrs: ['NR-10', 'NR-35', 'NR-6', 'NR-12'],
  stats: [
    { value: '+34%', label: 'Produtividade' },
    { value: '100%', label: 'Comprovação' },
    { value: '-45%', label: 'Atrasos' },
    { value: '24/7', label: 'Monitoramento' },
  ],
  testimonial: {
    quote: 'Finalmente conseguimos ter visibilidade do que acontece em campo. O WorkStream transformou nossa operação.',
    author: 'Roberto Alves',
    role: 'Gerente de Operações',
    company: 'TeleNord Comunicações',
  },
}

export default function Telecomunicacoes() {
  return <SegmentPage segment={segment} />
}

